import { generateClient } from 'aws-amplify/api';
import { getCurrentUser } from 'aws-amplify/auth';
import * as mutations from '../graphql/mutations';
import * as queries from '../graphql/queries';

const client = generateClient();

export const getPathfinderCSTDomainKeyByIndex = (index) => {
  const domainKeys = [
    "Operative Experience",
    "Surgical Experience",
    "Quality Improvement/Audit",
    "Presentations/Publications",
    "Teaching Experience"
  ];
  
  const numericIndex = Number(index);
  if (isNaN(numericIndex)) {
    return `Unknown domain ${index}`;
  }
  
  return domainKeys[numericIndex] || `Unknown domain ${index}`;
};

const isNumericDomainKey = (key) => {
  return !isNaN(Number(key)) && key !== null && key !== '';
};

export const savePathfinderCSTDomainScore = async (domainKey, points) => {
  try {
    const textDomainKey = isNumericDomainKey(domainKey) 
      ? getPathfinderCSTDomainKeyByIndex(Number(domainKey))
      : domainKey;
    
    const user = await getCurrentUser();
    if (!user) throw new Error('User not authenticated');

    console.log(`Saving PathfinderCSTDomainScore: domainKey="${textDomainKey}", points=${points}`);

    const { data } = await client.graphql({
      query: queries.listPathfinderCSTDomainScores,
      variables: {
        filter: { 
          userId: { eq: user.username }, 
          domainKey: { eq: textDomainKey }
        }
      },
      authMode: 'userPool'
    });

    const existingRecord = data.listPathfinderCSTDomainScores.items[0];

    if (existingRecord) {
      const input = {
        id: existingRecord.id,
        userId: user.username,
        domainKey: textDomainKey,
        progress: points,
        owner: user.username,
        _version: existingRecord._version
      };

      console.log('Updating existing CST record with input:', input);
      const result = await client.graphql({
        query: mutations.updatePathfinderCSTDomainScore,
        variables: { input },
        authMode: 'userPool'
      });
      
      console.log('CST Update successful:', result);
      return result;
    } else {
      const input = {
        userId: user.username,
        domainKey: textDomainKey,
        progress: points,
        owner: user.username
      };

      console.log('Creating new CST record with input:', input);
      const result = await client.graphql({
        query: mutations.createPathfinderCSTDomainScore,
        variables: { input },
        authMode: 'userPool'
      });
      
      console.log('CST Create successful:', result);
      return result;
    }
  } catch (error) {
    console.error('Error saving Pathfinder CST domain score:', error);
    throw error;
  }
};

export const fetchAllPathfinderCSTDomainScores = async () => {
  try {
    const user = await getCurrentUser();
    if (!user) throw new Error('User not authenticated');

    const { data } = await client.graphql({
      query: queries.listPathfinderCSTDomainScores,
      variables: {
        filter: { userId: { eq: user.username } },
        limit: 100
      },
      authMode: 'userPool'
    });

    return data.listPathfinderCSTDomainScores.items;
  } catch (error) {
    console.error('Error fetching Pathfinder CST domain scores:', error);
    return [];
  }
};
